<template>
  <div>
    <div class="langswitcher">
      <Langswitcher />
    </div>
    <div class="hamburger" v-bind:class="{ open: showMobile }" v-on:click="toggleShowMobile">
      <div class="line"></div>
    </div>
    <div class="mobile-menu" v-bind:class="{ open: showMobile }" v-show="showMobile" v-on:click="toggleShowMobile">
      <ul class="menu-items">
        <li v-for="(menuItem, index) in menuItems" v-bind:key="`menu-${index}`" v-on:click="scrollHistorySection">
          <a>
            <span class="label" v-html="menuItem"></span>
          </a>
        </li>
      </ul>
    </div>
    <div class="desktop-menu">
      <ul class="menu-items">
        <li v-for="(menuItem, index) in menuItems" v-bind:key="`menu-${index}`" v-on:click="scrollHistorySection">
          <a>
            <span class="label" v-html="menuItem"></span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Langswitcher from '@/components/Langswitcher.vue';

import { TweenMax, Power2 } from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import 'intersection-observer'

window.ScrollToPlugin = ScrollToPlugin

export default {
  name: "Menu",
  components: {
    Langswitcher
  },
  props: {
    bus: {}
  },
  data() {
    return {
      showMobile: false,
      visibleElements: []
    };
  },
  computed: {
    menuItems() {
      return [
        this.$i18n.t('home.about.title'),
        this.$i18n.t('home.struttura.title'),
        this.$i18n.t('home.storia.overtitle_year') + ' ' + this.$i18n.t('home.storia.seventies.year'),
        this.$i18n.t('home.storia.overtitle_year') + ' ' + this.$i18n.t('home.storia.eighties.year'),
        this.$i18n.t('home.storia.overtitle_year') + ' ' + this.$i18n.t('home.storia.nineties.year'),
        this.$i18n.t('home.storia.overtitle_year') + ' ' + this.$i18n.t('home.storia.oo.year'),
        this.$i18n.t('home.storia.overtitle_year') + ' ' + this.$i18n.t('home.storia.ten.year'),
        this.$i18n.t('home.storia.overtitle_year') + ' ' + this.$i18n.t('home.storia.twenty.year'),
        this.$i18n.t('home.contact.title')
      ]
    }
  },
  mounted() {
    
    /*
    let container = this.$el.querySelector(".mobile-menu > .menu-items");
    for (let item of this.$el.querySelectorAll(
      ".desktop-menu > .menu-items li"
    )) {
      let clone = item.cloneNode(true);
      container.appendChild(clone);
    }
    */

    let options = {
      rootMargin: '0px',
      threshold: 0
    };

    let previousY = 0
    let previousRatio = 0
    let state = {}
    let obs = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        const currentY = entry.boundingClientRect.y
        const currentRatio = entry.intersectionRatio
        const isIntersecting = entry.isIntersecting

        // Scrolling down/up
        if (currentY < previousY) {
          if (currentRatio > previousRatio && isIntersecting) {
            state.textContent ="Scrolling down enter"
            this.activateMenu(entry.target)
          } else {
            state.textContent ="Scrolling down leave"

            this.deactivateMenu(entry.target)
          }
        } else if (currentY > previousY && isIntersecting) {
          if (currentRatio < previousRatio) {
            state.textContent ="Scrolling up leave"
            this.deactivateMenu(entry.target)

          } else {
            state.textContent ="Scrolling up enter"
            this.activateMenu(entry.target)
          }
        } else {
          this.deactivateMenu(entry.target)
        }

        previousY = currentY
        previousRatio = currentRatio
      });
    }, options);

    for(let hi of document.querySelectorAll('.menu__target')) {
      obs.observe(hi);
    }
  },
  methods: {
    toggleShowMobile(e) {
      this.showMobile = !this.showMobile;
    },
    activateMenu(item) {
      let items = [...document.querySelectorAll('.menu__target')]
      let idx = items.indexOf(item)
      let force = (idx == items.length - 1 )
                ||
                (idx == 0 )

      if (force) {
        for (let f of this.$el.querySelectorAll('.desktop-menu .menu-items > li.active')) {
          f.classList.remove('active')
        }
      }
      if (this.$el.querySelectorAll('.desktop-menu .menu-items > li')[idx]) {
        if (force || this.visibleElements.length == 0 && !this.$el.querySelectorAll('.desktop-menu .menu-items > li.active').length) {
          console.log('activating', item, idx, this.visibleElements)

          this.$el.querySelectorAll('.desktop-menu .menu-items > li')[idx].classList.add('active')
          //this.visibleElements = this.visibleElements.filter((e) => {return e != this.$el.querySelectorAll('.desktop-menu .menu-items > li')[idx];})
          console.log('activated', this.visibleElements)
        } else {
          this.visibleElements.push(this.$el.querySelectorAll('.desktop-menu .menu-items > li')[idx])
          console.log('queuing', this.$el.querySelectorAll('.desktop-menu .menu-items > li')[idx])
        }
        
      }
    },
    deactivateMenu(item) {
      let items = [...document.querySelectorAll('.menu__target')]
      let idx = items.indexOf(item)
      

      if (this.$el.querySelectorAll('.desktop-menu .menu-items > li')[idx]) {
        console.log('deactivating', item, idx, this.visibleElements)
        this.$el.querySelectorAll('.desktop-menu .menu-items > li')[idx].classList.remove('active')
        this.visibleElements = this.visibleElements.filter((e) => {
          return e != this.$el.querySelectorAll('.desktop-menu .menu-items > li')[idx];
        })
      }
      if (this.visibleElements.length && !this.$el.querySelectorAll('.desktop-menu .menu-items > li.active').length) {
        console.log('activating fom queue', item, this.visibleElements[0])
        this.visibleElements[0].classList.add('active')
        this.visibleElements.splice(0, 1)
      }

    },
    scrollHistorySection(e) {
      let item = e.currentTarget
      let items = [...item.parentNode.querySelectorAll('li')]
      let idx = items.indexOf(item)
      let pos = document.querySelectorAll('.menu__target')[idx].getBoundingClientRect().top + window.scrollY
      TweenMax.to(window, 1, { scrollTo: { y: pos, autoKill: false }, ease: Power2.easeOut});

    }

  }
};
</script>

<style lang="scss" scoped>
.langswitcher {
  position: absolute;
  top: 18px;
  left: calc(100% - 140px);
  z-index: 22;
  @include media-breakpoint-up(xl) {
    left: calc(100% - 60px);
  }

  /deep/ select {
    background: transparent;
    color: white;
    border: none;
    outline: none;
    appearance: none;
    cursor: pointer;
    text-align: left;
  }
}
.hamburger {
  position: fixed;
  z-index: 22;
  top: 20px;
  right: 30px;
  display: block;
  height: 20px;
  width: 30px;
  cursor: pointer;
  overflow: hidden;
  .line {
    background: white;
    position: relative;
    top: 8.5px;
    width: 100%;
    height: 2px;
    transition: transform 0.2s ease-in;
  }
  &:after,
  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    background: white;
    transition: transform 0.2s ease-in 0.1s;
    transform-origin: 0 0;
  }
  &:after {
    top: 18px;
  }
  &.open {
    .line,
    &:before,
    &:after {
      background: white;
    }
    &:before {
      transform: rotate(37deg);
    }
    &:after {
      transform: rotate(-37deg);
    }
    .line {
      transform: translateX(100%);
    }
  }
}

.mobile-menu {
  position: fixed;
  z-index: 21;
  width: 100%;
  height: 100%;
  background: black;
  color: white;

  a {
    &, &:hover {
      color: white;
    }
  }
  .menu-items {
    margin-top: 100px;
    margin-left: 5vw;
    li {
      list-style: none;
      margin-bottom: 5px;
      font-family: $headings-font-family;
      font-size: 1.5rem;
    }
    > li > a {
      cursor: pointer;
      position: relative;
      &:after {
        display: inline-block;
        position: absolute;
        left: 100%;
        top: -0.45em;
        content: '.';
        color: $red;
        margin-left: 2px;
        font-size: 1.5em;
      }
    }
  }
}
        

.hamburger,
.mobile-menu {
  display: block;
  @include media-breakpoint-up(xl) {
    display: none;
  }
}

.desktop-menu {
  @include media-breakpoint-down(md) {
    display: none;
  }
  position: fixed;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  z-index: 11;
  font-size: 14px;
  font-family: $headings-font-family;
  text-align: right;
  @include media-breakpoint-down(lg) {
    .label {
      display: none;
    }
  }

  li {
    list-style: none;
    margin-top: 15px;
    margin-bottom: 15px;
    position: relative;
    cursor: pointer;
    &:after {
      content: "";
      display: inline-block;
      margin-left: 5px;
      width: 12px;
      height: 3px;
      border-bottom: 1px solid $light-gray;
      transition: transform 0.4s ease-out;
      transform: translateY(-4px)
    }
    &.active:after {
      border-color: $red;
    }
    
    @media (min-height: 1000px) {
      margin-bottom: 30px;
      &:before {
        height: 38px;
        top: 95%;
      }
    }
  }
  a {
    &, &:hover {
      color: $light-gray;
    }
    &:hover {
      text-decoration: none;
    }
  }
  .active a {
    color: $red;
  }
}
</style>
